interface Identifiable {
  id?: string | number | null;
  key?: string | number | null;
}

interface WithIsDeleted {
  isDeleted?: boolean;
}

export const markDeletedItems = <T extends Identifiable>(
  selected: T[], 
  available: Identifiable[]
): (T & WithIsDeleted)[] => {
  const ids = new Set(available.map(a => (a.id ?? a.key)?.toString()));
  
  return selected.map(item => {
    const itemId = (item.id ?? item.key)?.toString();
    return {
      ...item,
      isDeleted: itemId ? !ids.has(itemId) : true
    };
  });
};